export default function Excel_Highlight_Cell_Rules() {
  return <div>Excel_Highlight_Cell_Rules</div>;
}
